export default "__VITE_ASSET__d44e6c5d__"